import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {toggleMenu, setContent, activeMenu} from '../../actions';
import {componentIcons} from '../../config/components';
import {Link} from "react-router-dom";
import classNames from "classnames";
import http_build_query from "locutus/php/url/http_build_query";
import urldecode from "locutus/php/url/urldecode";
import Icon from "../form/Icon";
import {autoAnimate} from "../../utils/animate/AutoAnimate";

class SubMenu extends React.Component {

    render () {
        return <ul ref={this.props.animationRef} className={classNames("treeview-menu")}>
            {
                this.props.opened ? this.props.items.map((item, idx) => {
                    if(item.items && item.items.length && item.token !== "separator") {
                        return <ConnectedMenuItem
                            key={idx}
                            ref={(item) => {
                                if (idx === 0) {
                                    this.items = [];
                                }
                                this.items.push(item);
                                if (this.items.length === idx + 1) {
                                    this.height = this.items.filter((item) => !!item).map((item) => item.clientHeight).reduce((accumulator, currentHeight) => accumulator + (currentHeight || 999), 0);
                                }
                            }}
                            level={this.props.level}
                            {...item}
                            icon={"circle-o"}
                        />;
                    } else {
                        let token = item.token;
                        let link = "";
                        if(item.link === undefined || item.link === "" || item.link === null) {
                            let query = {option: token};
                            if (token.indexOf(".") !== -1) {
                                const s = token.split(".", 2);
                                token = s[0];
                                query.option = token;
                                query.id = s[1];
                            }
                            if (this.props.editors[token] && this.props.editors[token].componentConfig && this.props.editors[token].values && this.props.editors[token].values[this.props.editors[token].componentConfig.idfield]) {
                                query[this.props.editors[token].componentConfig.idfield] = this.props.editors[token].values[this.props.editors[token].componentConfig.idfield];
                            }
                            link = "?" + urldecode(http_build_query(query));
                        } else {
                            link = item.link;
                        }
                        let edit = null;
                        if (this.props.editors[token] && this.props.editors[token].dirty) {
                            edit = <small className={"label pull-right bg-red"}>!</small>;
                        }

                        return <li key={idx} ref={(item) => {
                            if (idx === 0) {
                                this.items = [];
                            }
                            this.items.push(item);
                            if (this.items.length === idx + 1) {
                                this.height = this.items.filter((item) => !!item).map((item) => item.clientHeight).reduce((accumulator, currentHeight) => accumulator + (currentHeight || 999), 0);
                            }
                        }} className={classNames({"active": item.active, "separator": token === "separator"})}>
                            <Link
                                to={link}
                            >
                                <Icon lib="fa" name={(componentIcons[token] || "circle-o")}/>{typeof item.label === "object" ? "[Object object]" : item.label}
                                {edit}
                            </Link>
                        </li>;
                    }
                }) : null
            }
        </ul>;
    }
}

const ConnectedSubMenu = connect((state) => {
    return {
        editors: state.editors
    };
}, {toggleMenu, setContent, activeMenu})(autoAnimate(SubMenu));

class MenuItem extends React.Component {

    toggleMenu = (e) => {
        e.preventDefault();
        (this.props.level || !this.props.sidebar.sidebarCollapsed) && this.props.toggleMenu(this.props.token, !this.props.opened || this.props.sidebar.sidebarCollapsed);
    };

    render() {
        const content = <Fragment>
            {componentIcons[this.props.token] ?
                <Icon lib="fa" name={componentIcons[this.props.token]}/>
                :
                (this.props.icon ? <Icon lib="fa" name={this.props.icon}/> : <Icon lib="fa" name="none"/>)
            }
            <span>{this.props.label}</span>
            {this.props.items && this.props.items.length && <span className="pull-right-container">
                <Icon lib="fa" name="angle-left"/>
            </span> || null}
        </Fragment>;

        let token = this.props.token;
        let link = "";
        if(this.props.link === undefined || this.props.link === "" || this.props.link === null) {
            let query = {option: token};
            if (token.indexOf(".") !== -1) {
                const s = token.split(".", 2);
                token = s[0];
                query.option = token;
                query.id = s[1];
            }
            if (this.props.editors[token] && this.props.editors[token].componentConfig && this.props.editors[token].values && this.props.editors[token].values[this.props.editors[token].componentConfig.idfield]) {
                query[this.props.editors[token].componentConfig.idfield] = this.props.editors[token].values[this.props.editors[token].componentConfig.idfield];
            }
            link = "?" + urldecode(http_build_query(query));
        } else {
            link = this.props.link;
        }
        if (
            (this.props.level !== undefined && this.props.level !== 0)
            ||
            (
                //(link !== "" && link !== null && link !== undefined)
                //||
                this.props.items?.filter((item) => item.token !== "separator")?.length
                ||
                this.props.token === "separator"
            )
        ) {
            return (
                <li className={classNames("treeview", {
                    "active": this.props.active,
                    "menu-open": this.props.opened || this.props.sidebar.sidebarCollapsed,
                    "separator": this.props.token === "separator"
                })}>
                    {this.props.items && this.props.items.length ? <a href="#" onClick={this.toggleMenu}>
                        {content}
                    </a> : <Link
                        to={link}>{content}</Link>}
                    {
                        this.props.token !== "separator" &&
                        <ConnectedSubMenu level={(this.props.level || 0) + 1} items={this.props.items}
                                          opened={this.props.opened || this.props.sidebar.sidebarCollapsed}/>
                    }
                </li>
            );
        } else {
            return null;
        }
    }
}

const ConnectedMenuItem = connect((state) => {
    return {
        sidebar: state.app.template.sidebar,
        editors: state.editors
    };
}, {toggleMenu, setContent, activeMenu})(MenuItem);

export default ConnectedMenuItem;